declare global {
	interface Window {
		electron: {
			storeClientData: (data: PersistedClientData) => void;
		};
	}
}

export const StorageKeys: {
	readonly StaticHostData: string;
	readonly NetworkInterfaces: string;
	readonly PersistedClientData: string;
} = {
	StaticHostData: "StaticHostData",
	NetworkInterfaces: "NetworkInterfaces",
	PersistedClientData: "PersistedClientData",
};

export const FunctionNames: {
	readonly WifiConnection: string;
	readonly NetworkInterfaces: string;
} = {
	WifiConnection: "setWifi",
	NetworkInterfaces: "setNetworkInterfaces",
};

export interface StaticHostData {
	hostname: string;
}

export interface NetworkInterface {
	adapter: string;
	family: "IPv4" | "IPv6" | null;
	address: string;
	netmask: string;
	mac: string;
}

export interface PersistedClientData {
	// A unique identifier for the device - generated by the server, and passed to the electron application for persistence.
	deviceId: string;
}

export interface WifiData {
	name: string;
	strength: number;
}
